export default __webpack_public_path__ + "beta-maps-guides-outdoors-1200-42b35b36fd0fd82494595db56605e894.png";